import React from 'react';

const SidebarName = () => {
    return (
        <span style={{ fontSize: '1.3rem', fontWeight: '800', color: 'var(--primary)', whiteSpace: 'nowrap' }}>
            Smart SIP
        </span>
    );
};

export default SidebarName;
